export const EXPORT_FUND_FIELDS = {
  fundCode: 'Fund code',
  activeFundCodeVsExpClasses: 'Fund and active expense class codes',
};
